var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserDefaultWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58.07,
    height: 64.05,
    viewBox: "0 0 58.07 64.05",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    overflow: "visible",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Profile_1_"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.02,
    cy: 15.27,
    r: 15.27,
    id: "XMLID_2_",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.2 34.71 14.88 34.71C6.94 34.71 0.47 40.91 0 48.73 2.79 52.8 6.41 56.25 10.62 58.84L10.62 50.65C10.62 50.14 11.03 49.73 11.54 49.73L11.54 49.73C12.05 49.73 12.46 50.14 12.46 50.65L12.46 59.9C17.4 62.55 23.05 64.05 29.04 64.05 35.04 64.05 40.68 62.55 45.62 59.9L45.62 50.65C45.62 50.14 46.03 49.73 46.54 49.73L46.54 49.73C47.05 49.73 47.46 50.14 47.46 50.65L47.46 58.84C51.67 56.25 55.29 52.8 58.08 48.73 57.6 40.91 51.13 34.71 43.2 34.71Z",
    id: "XMLID_1_",
    fill: "#FFFFFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDefaultWhite);
export default __webpack_public_path__ + "static/media/user_default_white.a034e90b7f552c121d3fdebe779fc127.svg";
export { ForwardRef as ReactComponent };